import React from 'react'
import { Drawer, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import CircleLoader from 'components/Loading/CircleLoader'
import EditForm from './EditForm'
import messages from '../translate'

function SeawaterSiteListForm({
  intl: { formatMessage },
  onPanelClose,
  isFormOpened,
  isEditMode,
  isSavingForm,
  siteType,
  selectedSnapshot: snapshot,
  activeSite: { client, site: siteSIEP, region },
}) {
  return (
    <Drawer
      className="info-panel projected-sites-manager-form"
      variant="persistent"
      anchor="right"
      open={isFormOpened}
      classes={{
        paper: 'info-panel-paper',
      }}>
      <CircleLoader loading={isSavingForm} />
      <div className="info-panel-header">
        <Typography className="info-title" variant="subtitle1">
          {isEditMode ? (
            <>
              {!!client && <span>{client}</span>}
              {!!siteSIEP && <span>{siteSIEP}</span>}
              {!!region && <span>{region}</span>}
            </>
          ) : (
            formatMessage(messages.newRow)
          )}
        </Typography>
        <div className="action-group">
          <IconButton size="small" onClick={onPanelClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <EditForm
        onPanelClose={onPanelClose}
        isEditMode={isEditMode}
        siteType={siteType}
        snapshot={snapshot}
      />
    </Drawer>
  )
}

export default connect(state => ({
  activeSite: state.getIn(['projectedSitesManager', 'activeSite']),
  isSavingForm: state.getIn(['projectedSitesManager', 'isSavingForm']),
}))(injectIntl(SeawaterSiteListForm))
